export default __webpack_public_path__ + "static/media/me7.57842c0d.gif";